module.exports = __webpack_public_path__ + "img/openIcon.68560bce.png";